import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import '../styles/LanguageSelector.css';

import DiamondVPNService from '../services/api';

const LanguageSelector = ({ isAuthenticated = false }) => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { code: 'ru', name: 'Русский', flag: '🇷🇺' },
    { code: 'en', name: 'English', flag: '🇺🇸' }
  ];

  // Закрытие dropdown при клике вне компонента
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleLanguageChange = async (languageCode) => {
    i18n.changeLanguage(languageCode);
    try {
      if (isAuthenticated) {
        await DiamondVPNService.setUserLanguage(languageCode);
      }
    } catch (e) {
      console.error('Failed to persist language:', e);
    }
    setIsOpen(false);
  };

  const currentLanguage = languages.find(lang => lang.code === i18n.language);

  return (
    <div className="language-selector" ref={dropdownRef}>
      <div className="language-dropdown">
        <button 
          className="language-current"
          onClick={toggleDropdown}
          aria-expanded={isOpen}
          aria-haspopup="true"
        >
          <span className="language-flag">
            {currentLanguage?.flag}
          </span>
          <span className="language-name">
            {currentLanguage?.name}
          </span>
          <i className={`fas fa-chevron-down ${isOpen ? 'open' : ''}`}></i>
        </button>
        
        <div className={`language-options ${isOpen ? 'open' : ''}`}>
          {languages.map(language => (
            <button
              key={language.code}
              className={`language-option ${i18n.language === language.code ? 'active' : ''}`}
              onClick={() => handleLanguageChange(language.code)}
            >
              <span className="language-flag">{language.flag}</span>
              <span className="language-name">{language.name}</span>
              {i18n.language === language.code && (
                <i className="fas fa-check check-icon"></i>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageSelector;
